/* assets/trepsa-step-thickness.js — Schritt 5: Stärke der Trittstufe */
(() => {
  "use strict";

  function init() {
    const root = document.querySelector("[data-trepsa-thickness]");
    if (!root) return;

    const input  = root.querySelector("[data-thickness-input]");
    const errBox = root.querySelector("[data-thickness-error]");
    if (!input) return;

    const digits = (raw) => String(raw || "").replace(/[^\d]/g, "");

    function validate(value) {
      if (!value) return null;
      const n = Number(value);
      if (n <= 0)  return "Bitte einen Wert größer als 0 eingeben.";
      if (n > 100) return n + " mm überschreitet das Maximum von 100 mm.";
      return null;
    }

    function setError(msg) {
      if (errBox) {
        errBox.textContent = msg || "";
        errBox.style.display = msg ? "" : "none";
      }
      input.classList.toggle("is-error", !!msg);
    }

    function emit(value) {
      window.dispatchEvent(new CustomEvent("trepsa:thickness:update", {
        detail: { thickness: value, priceCents: 0 }
      }));
    }

    input.addEventListener("input", () => {
      const clean = digits(input.value);
      input.value = clean;
      const err = validate(clean);
      setError(err);
      const val = !err && clean ? clean : "";
      try { localStorage.setItem("trepsa_thickness", val); } catch (_) {}
      emit(val);
    });

    // Gespeicherten Wert wiederherstellen
    let saved = "";
    try { saved = localStorage.getItem("trepsa_thickness") || ""; } catch (_) {}
    if (saved && !validate(saved)) {
      input.value = saved;
      emit(saved);
    } else {
      emit("");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();